import type { Todo } from "../../domain/entities.ts";

export type DependencyState = "complete" | "blocking" | "archived" | "deleted" | "unavailable";
export interface DependencyReadinessItem { id: string; state: DependencyState; task?: Todo }

/** Missing authorized data is unknown, never evidence of completion. */
export function dependencyReadiness(task: Pick<Todo, "dependencyIds" | "rootId">, tasks: readonly Todo[]) {
  if (!task.dependencyIds?.length) return { items: [] as DependencyReadinessItem[], resolved: 0, unresolved: [] as DependencyReadinessItem[] };
  const available = new Map(tasks.map(item => [item.id, item]));
  const items: DependencyReadinessItem[] = [...new Set(task.dependencyIds || [])].map(id => {
    const dependency = available.get(id);
    if (!dependency || dependency.rootId !== task.rootId) return { id, state: "unavailable" };
    if (dependency.deleted) return { id, state: "deleted" };
    if (dependency.completed) return { id, state: "complete", task: dependency };
    return { id, state: dependency.archivedAt ? "archived" : "blocking", task: dependency };
  });
  return { items, resolved: items.filter(item => item.state === "complete").length, unresolved: items.filter(item => item.state !== "complete") };
}

export function taskIsReady(task: Todo, tasks: readonly Todo[]): boolean {
  return !task.completed && !task.deleted && !task.archivedAt && !dependencyReadiness(task, tasks).unresolved.length;
}
